import { datadogRum } from '@datadog/browser-rum-slim';

import { mergeLDContextKeyAttributes } from './internal/ldContextKeyAttributes';
import { nrSetCurrentRouteName, nrSetCustomAttribute, nrSetPageViewName } from './internal/newRelicRum';

export const DEFAULT_OWNER = 'team-foundation';

export function setRouteContext(pattern: string, owner?: string) {
  datadogRum.setGlobalContextProperty('pathTemplate', pattern);
  datadogRum.setGlobalContextProperty('owner', owner ?? DEFAULT_OWNER);
  nrSetCustomAttribute('pathTemplate', pattern);
  nrSetCustomAttribute('owner', owner ?? DEFAULT_OWNER);
  nrSetCurrentRouteName(pattern);
  nrSetPageViewName(pattern);
  mergeLDContextKeyAttributes({ pathTemplate: pattern, owner: owner ?? DEFAULT_OWNER });
}
